"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PropDesc_1 = require("./PropDesc");

var DataPropDesc =
/*#__PURE__*/
function (_PropDesc_1$PropDesc) {
  _inherits(DataPropDesc, _PropDesc_1$PropDesc);

  function DataPropDesc(data, parser, description, validators) {
    var _this;

    _classCallCheck(this, DataPropDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataPropDesc).call(this, parser, description, validators));
    _this._data = data;
    return _this;
  }

  _createClass(DataPropDesc, [{
    key: "withMappedParser",
    value: function withMappedParser(spec, mapping) {
      throw new Error('Parser mapping not supported');
    }
  }, {
    key: "withDescription",
    value: function withDescription(descr) {
      return new DataPropDesc(this.data, this.parser, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitData(this);
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }]);

  return DataPropDesc;
}(PropDesc_1.PropDesc);

exports.DataPropDesc = DataPropDesc;